import { useState } from "react";
import { Link } from "react-router-dom";

import Carousel from "components/UI/Carousel/Carousel";
import Button from "components/UI/Button/Button";
// import ImagePreviewModal from "components/ImagePreviewModal/ImagePreviewModal";

import { EVENTS, metricsEvent } from "metrics";
import { CAROUSEL_REVIEWS_SLIDES } from "../../carouselData";

import "./ReviewsSection.scss";

const ReviewsSection = ({ isMobile }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="reviews-section">
      <div className="reviews-section__description">
        <h3 className="section__title">Отзывы наших клиентов</h3>
        <p className="section__text">
          Нам важно знать ваше мнение, напишите отзыв и помогите нам стать лучше
        </p>
      </div>
      <Carousel
        slides={CAROUSEL_REVIEWS_SLIDES}
        variant="compact"
        itemsVisible={isMobile ? 2 : 5}
        itemWidth={218}
        itemHeight={472}
        withRightFade={isMobile ? true : false}
        onSlideClick={(slide) => setSelectedImage(slide.image)}
        mobileExtraButton={
          <Link to={process.env.REACT_APP_SUPPORT_ADDRESS} target="_blank">
            <Button
              className="reviews-section__button-link"
              title="Написать отзыв"
              onClick={() => metricsEvent(EVENTS.TELEGRAM_HELP)}
            />
          </Link>
        }
        isMobile={isMobile}
      />
      {!isMobile && (
        <Link to={process.env.REACT_APP_SUPPORT_ADDRESS} target="_blank">
          <Button
            className="reviews-section__button-link"
            title="Написать отзыв"
            onClick={() => {
              metricsEvent(EVENTS.TELEGRAM_HELP);
            }}
          />
        </Link>
      )}

      {/* <ImagePreviewModal
        image={selectedImage}
        onClose={() => setSelectedImage(null)}
      /> */}
    </section>
  );
};

export default ReviewsSection;
